/**
 * Single source of truth for every socket event name + the round-status enum.
 *
 * To add / rename / remove an event you only touch THIS file — emitters,
 * listeners and the service all reference these constants, never raw strings.
 */

// ── Native Socket.IO lifecycle events ───────────────────────────────────────
export const NATIVE_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  RECONNECT: 'reconnect',
  RECONNECT_ATTEMPT: 'reconnect_attempt',
  RECONNECT_ERROR: 'reconnect_error',
  RECONNECT_FAILED: 'reconnect_failed',
}

// ── Client -> Server (things we emit) ───────────────────────────────────────
// There is deliberately NO cancel command: a bet is only sent to the server at
// the last moment before takeoff, and from that instant it is final.
export const CLIENT_EVENTS = {
  PLACE_BET: 'PLACE_BET',
  CASH_OUT: 'CASH_OUT',
  JOIN_ROOM: 'JOIN_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM',
  // re-request snapshots (no payload)
  GAME_STATS: 'GAME_STATS',
  LAST_MULTIPLIERS: 'LAST_MULTIPLIERS',
}

// ── Server -> Client (things we listen for) ─────────────────────────────────
export const SERVER_EVENTS = {
  // bootstrap / reconnect snapshot (pushed automatically on connect)
  GAME_STATS: 'GAME_STATS',
  ACTIVE_BET: 'ACTIVE_BET',
  LAST_MULTIPLIERS: 'LAST_MULTIPLIERS',
  // command replies (private)
  PLACE_BET_RESPONSE: 'PLACE_BET_RESPONSE',
  CASHOUT_RESPONSE: 'CASHOUT_RESPONSE',
  // room broadcasts (everyone in the game room)
  BET_PLACED: 'BET_PLACED',
  CASHED_OUT: 'CASHED_OUT',
  // private
  BET_SETTLED: 'BET_SETTLED',
  USER_BALANCE_UPDATE: 'USER_BALANCE_UPDATE',
}

// ── Round lifecycle statuses carried inside the dynamic game-state event ─────
export const GAME_STATUS = {
  SCHEDULED: 'SCHEDULED',
  ACCEPT_BET: 'ACCEPT_BET',
  STARTING: 'STARTING',
  RUNNING: 'RUNNING',
  ENDED: 'ENDED',
  UNDER_MAINTENANCE: 'UNDER_MAINTENANCE',
}

/**
 * The game-state tick event name is NOT a constant — it is the room name
 * itself: `${gameCode}/${gameMode}` (e.g. "CRASH/1"). Always build it here.
 */
export const getGameRoom = (gameCode, gameMode) => `${gameCode}/${gameMode}`
